module.exports = "/static-assets/_next/static/images/capture-549f64a463df5d35deceb7f311a610a3.png";